import React from 'react';
import Input from './Input';

import './css/OpenNewTab.css';

const OpenNewTab = ({ newTab, onChange }) => (
  <form className="OpenNewTab">
    <Input
      type="checkbox"
      id="newtab"
      name="newtab"
      defaultChecked={newTab}
      onChange={onChange}
      labelText="Open links in new tab"
    />
  </form>
)

export default OpenNewTab;
